import { appApi } from "./api.service";
import {hasUnsignedContracts} from "./contract.service";
import {Links} from "../app/links";
import {SignType} from "@modals/sign/sign.types";
import {hasWorkerAccessToCalendar} from "@utils/tools/worker";

let endpointPrefix = 'user/profile';

const getProfile = async (skipAuthRefresh: boolean = false) => {
    return appApi.get(endpointPrefix, <any>{
		skipAuthRefresh: skipAuthRefresh,
		headers: {
			'No-Loader': true
		}
	});
}

const getCities = async(keyword: string) => {
	return appApi.get('user/cities?keyword=' + keyword + '&unique=1', {
		headers: {
			'No-Loader': true
		}
	});
}

export const getCitiesData = async(keyword: string) => {
	return appApi.get('user/cities?keyword=' + keyword + '&unique=1&char=2&format=1', {
		headers: {
			'No-Loader': true
		}
	});
}

const updateInlineFieldValue = async (field: string, value: string, signType?: SignType) => {
	return appApi.post(endpointPrefix + '/' + field + '/update', {
		[field]: value,
		signType: signType,
	});
}

const updatePhoneFieldValue = async (value: string, code: string) => {
	return appApi.post(endpointPrefix + '/phone-save/update', {
		'phone': value,
		'verificationCode': code,
	});
}

const updateAcceptanceFieldValue = async (action: string, field: string, value: boolean) => {
	return appApi.post('user/' + action + '/update', {
		[field]: value,
	});
}

const updateLanguages = async(languages:string[], levels:string[]) => {
	let data = { languages: languages, levels: levels };
	return appApi.post(endpointPrefix + '/languages/update', data);
}

const updateCourses = async(courses:string[], details:string[]) => {
	let data = { courses: courses, details: details };
	return appApi.post(endpointPrefix + '/courses/update', data);
}

const updateCity = async(city: string) => {
	let data = { city: city };
	return appApi.post(endpointPrefix + '/city/update', data);
}

const updateLang = async(lang: string) => {
	let data = { lang: lang };
	return appApi.post(endpointPrefix + '/language/update', data);
}

const generateBotToken = async() => {
	return appApi.post( 'user/generate-bot-token', {});
}

const generateBenefitsToken = async() => {
	return appApi.post( 'user/generate-benefits-token', {});
}

const uploadPhoto = async(photo: Blob, refresh: boolean) => {
	let formData = new FormData();

	// Generate filename with proper extension based on blob type
	let filename = 'avatar.jpg';
	if (photo.type) {
		const mimeToExt = photo.type.split('/')[1];
		if (mimeToExt && ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(mimeToExt.toLowerCase())) {
			const ext = mimeToExt.toLowerCase() === 'jpeg' ? 'jpg' : mimeToExt.toLowerCase();
			filename = `avatar.${ext}`;
		}
	}

	formData.append("photo", photo, filename);
	return appApi.post(endpointPrefix + '/photo/upload', formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		}
	});
}

const getRedirectAfterLogin = async (number: string|null) => {
	if (number) {
		const hasUnsigned = await hasUnsignedContracts();
		const hasAccessToCalendar = await hasWorkerAccessToCalendar();

		if (hasUnsigned) {
			return Links.main + Links.contracts;
		}

		if (hasAccessToCalendar) {
			return Links.main + Links.availability;
		}
	}

	return Links.main + Links.profile;
}

const getRoles = async () => {
	return appApi.get(endpointPrefix + '/roles');
}

export const removeUser = async () => {
	return appApi.delete( 'user/remove');
}

export const setPin = async (pin: string) => {
	return appApi.post( 'user/set-pin', {
		'pin': pin
	});
}

export const turnOffPin = async () => {
	return appApi.post( 'user/turn-off-pin', {});
}

export {
	getProfile,
	getCities,
	updateInlineFieldValue,
	updatePhoneFieldValue,
	updateAcceptanceFieldValue,
	updateLanguages,
	updateCourses,
	updateCity,
	uploadPhoto,
	getRedirectAfterLogin,
	getRoles,
	updateLang,
	generateBotToken,
	generateBenefitsToken
};
